/**
 * Common activity types shared across all entities.
 * Entity-specific activity type definitions extend this with additional types.
 *
 * These types represent actions that are common to most entities:
 * - Lifecycle events (created, updated, deleted)
 * - Notes management
 * - Tasks management
 * - File attachments
 * - Entity linking
 * - Status and assignment changes
 * - AI interactions
 */
export enum CommonActivityType {
	// Lifecycle
	CREATED = 'created',
	UPDATED = 'updated',
	DELETED = 'deleted',
	RECOVERED = 'recovered',

	// Notes
	NOTE_ADDED = 'note_added',
	NOTE_UPDATED = 'note_updated',
	NOTE_DELETED = 'note_deleted',

	// Tasks
	TASK_LINKED = 'task_linked',
	TASK_UNLINKED = 'task_unlinked',
	TASK_CREATED = 'task_created',
	TASK_COMPLETED = 'task_completed',
	TASK_UPDATED = 'task_updated',
	TASK_DELETED = 'task_deleted',

	// Files
	FILE_ATTACHED = 'file_attached',
	FILE_REMOVED = 'file_removed',

	// Generic entity linking
	ENTITY_LINKED = 'entity_linked',
	ENTITY_UNLINKED = 'entity_unlinked',

	// Common field changes
	STATUS_CHANGED = 'status_changed',
	PRIORITY_CHANGED = 'priority_changed',
	ASSIGNEE_CHANGED = 'assignee_changed',

	// Watchers
	WATCHER_ADDED = 'watcher_added',
	WATCHER_REMOVED = 'watcher_removed',

	// AI
	AI_SESSION = 'ai_session',
}

export type CommonActivityTypeValue =
	(typeof CommonActivityType)[keyof typeof CommonActivityType];
